import { gql } from '@apollo/client';

const GET_SCAN_ID_ONHAND_DISPATCH_REPORT_KERRY = gql`
    query getCustomWarehouseScanIDOnhandDispatchedKerryReport {
        getCustomWarehouseScanIDOnhandDispatchedKerryReport {
            code
            success
            message
            count
            results
        }
    }
  `;

export default GET_SCAN_ID_ONHAND_DISPATCH_REPORT_KERRY;
